import './styles.scss';

import { ReactElement, ReactNode } from 'react';

import { Badge } from 'react-bootstrap';
import { DynamicCellRenderer } from '@/common/Table/cells/DynamicCell';
import Tippy from '@tippyjs/react';
import { getClasses } from '@/utils';

export type TooltipCellProps = {
  label: string;
  lines: string[];
  className?: string;
};

const TOOLTIP_PATTERN = /^TOOLTIP::(\{.*\})$/s;

const TooltipCell = ({ label, lines, className }: TooltipCellProps): ReactElement => {
  if (!lines.length) {
    return <span className={getClasses('TooltipCell', 'TooltipCell--empty', 'badge', 'rounded-pill', className)}>{label}</span>;
  }
  return (
    <Tippy
      theme="primary"
      placement="left"
      content={
        <ul className="TooltipCell-Lines">
          {lines.map((line, i) => (
            <li key={i}>{line}</li>
          ))}
        </ul>
      }
    >
      <Badge pill bg="none" className={getClasses('TooltipCell', className)}>
        <Badge pill bg="none" className="TooltipCell-Icon" aria-hidden="true">
          i
        </Badge>
        {label}
      </Badge>
    </Tippy>
  );
};

export const tooltipCellRenderer: DynamicCellRenderer = {
  test: (value: string) => TOOLTIP_PATTERN.test(value),
  render: (value: string): ReactNode => {
    try {
      const { label, lines } = JSON.parse(value.match(TOOLTIP_PATTERN)[1]);
      if (typeof label !== 'string') return value;
      return <TooltipCell label={label} lines={Array.isArray(lines) ? lines.map(String) : []} />;
    } catch {
      return value;
    }
  },
};

export default TooltipCell;
